import { IconCheck, UndoneIcon } from "./IconsStyle.styled";

export const IconDone = () => {
  return (
    <IconCheck viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="#fff"
        d="M12.734 20.2l11.3-11.3c0.267-0.267 0.578-0.4 0.933-0.4s0.667 0.133 0.933 0.4c0.267 0.267 0.4 0.584 0.4 0.951s-0.133 0.684-0.4 0.949l-12.233 12.267c-0.267 0.267-0.578 0.4-0.933 0.4s-0.667-0.133-0.933-0.4l-5.733-5.733c-0.267-0.267-0.395-0.583-0.384-0.949s0.15-0.683 0.417-0.951c0.268-0.268 0.584-0.401 0.951-0.4s0.683 0.134 0.949 0.4l4.733 4.767z"
      ></path>
    </IconCheck>
  );
};

export const UnConfirmEmailIcon = () => {
  return (
    <>
      <UndoneIcon viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <path
          fill="#fff"
          d="M24.401 7.614c-0.123-0.124-0.27-0.222-0.431-0.289s-0.334-0.101-0.509-0.101c-0.175 0-0.348 0.034-0.509 0.101s-0.308 0.165-0.431 0.289l-6.52 6.507-6.52-6.52c-0.123-0.123-0.27-0.221-0.431-0.288s-0.334-0.101-0.509-0.101c-0.175 0-0.347 0.034-0.509 0.101s-0.308 0.165-0.431 0.288c-0.123 0.123-0.221 0.27-0.288 0.431s-0.101 0.334-0.101 0.509c0 0.175 0.034 0.347 0.101 0.509s0.165 0.308 0.288 0.431l6.52 6.52-6.52 6.52c-0.123 0.123-0.221 0.27-0.288 0.431s-0.101 0.334-0.101 0.509c0 0.175 0.034 0.347 0.101 0.509s0.165 0.308 0.288 0.431c0.123 0.123 0.27 0.221 0.431 0.288s0.334 0.101 0.509 0.101 0.347-0.034 0.509-0.101c0.161-0.067 0.308-0.165 0.431-0.288l6.52-6.52 6.52 6.52c0.123 0.123 0.27 0.221 0.431 0.288s0.334 0.101 0.509 0.101 0.347-0.034 0.509-0.101c0.161-0.067 0.308-0.165 0.431-0.288s0.221-0.27 0.288-0.431c0.067-0.161 0.101-0.334 0.101-0.509s-0.034-0.347-0.101-0.509c-0.067-0.161-0.165-0.308-0.288-0.431l-6.52-6.52 6.52-6.52c0.507-0.507 0.507-1.36 0-1.867z"
        />
      </UndoneIcon>
    </>
  );
};
